<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-container(fluid)
        v-row
          v-col(cols="12" sm="6")
            BaseTextField(rules="required" v-model="form.name", :label="translations.label.name")
        v-row
          v-col(cols="12")
            BaseDynamicLevel(v-model="items", :title="translations.table.title", :headers="tableHeaders")
          v-col.pa-2.pa-md-6(cols="12")
            v-btn.float-right.big(:disabled="invalid || checkPercentage != 100"
              color="primary"
              type="submit"
              :loading="loadingEdit") {{ translations.button.edit }}
</template>

<script>

  export default {
    name: "CategoryEdit",
    props:{
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      category:{
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data:() => ({
      form:{
        name: '',
      },
      items: []
    }),
    computed: {
      loadingEdit() {
        return this.$store.state.statusCode.editCategories.loading;
      },
      stateEdit() {
        return this.$store.state.statusCode.editCategories.state;
      },
      tableHeaders(){
        return [
          this.translations.table.level,
          this.translations.table.name,
          this.translations.table.points,
          this.translations.table.rolldown,
          this.translations.table.percentage,
        ];
      },
      checkPercentage(){
        if(this.items.length){
          return this.items.reduce((acc,cur)=>{
            return acc + cur.percentage;
          }, 0);
        } else {
          return 0;
        }
      }
    },
    watch: {
      clearForm: function(val){
        if (val){
          this.setFields();
          this.$refs.validator.reset();
        }
      },
      stateEdit: function(val){
        if (val == 200){
          this.$emit('successEdit');
        }
      },
    },
    created(){
      this.setFields();
    },
    methods:{
      submitDataForm(){
        let formSend = {
          data: {
            name: this.form.name,
            items: this.items,
          },
        };
        this.$store.dispatch('editCategories', formSend);
      },
      setFields(){
        this.form.name = this.category.name;
        this.items = this.category.items.map((item)=>{
          return {
            name: item.n,
            percentage: parseInt(item.pct),
            points: parseInt(item.p),
            rollDown: item.rd == 'true',
          }
        });
      },
    }
  }
</script>

<style lang="sass">
</style>